import styled from "styled-components";
import { device } from "../../../../globalStyles/breakpoints";

export const LightboxBackdrop = styled.div`
  position: fixed;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 4;
  left: 0;
  right: 0;
  top: 0;
  animation: fadeIn;
  animation-duration: 0.5s;
`;

export const Lightbox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px auto;
  width: 100%;
`;

export const LightboxImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;

  ${device.desktop} {
    width: 60%;
  }
`;

export const LightboxImage = styled.div`
  width: 100%;
  height: 77vh;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: 25px;
  margin-right: 25px;
  animation: fadeIn;
  animation-duration: 1.5s;
`;
